import React from "react";
import Chart from "react-apexcharts";

const SiteAgingHeatmap = () => {
  const series = [
    {
      name: "Site 01",
      data: [
        { x: "0–2 DAYS", y: 6 },
        { x: "3–5 DAYS", y: 4 },
        { x: "6–10 DAYS", y: 7 },
        { x: "11–15 DAYS", y: 1 },
        { x: "16–30 DAYS", y: 6 },
        { x: ">30 DAYS", y: 7 },
      ],
    },
    {
      name: "Site 02",
      data: [
        { x: "0–2 DAYS", y: 10 },
        { x: "3–5 DAYS", y: 14 },
        { x: "6–10 DAYS", y: 5 },
        { x: "11–15 DAYS", y: 10 },
        { x: "16–30 DAYS", y: 14 },
        { x: ">30 DAYS", y: 29 },
      ],
    },
    {
      name: "Site 03",
      data: [
        { x: "0–2 DAYS", y: 2 },
        { x: "3–5 DAYS", y: 6 },
        { x: "6–10 DAYS", y: 6 },
        { x: "11–15 DAYS", y: 3 },
        { x: "16–30 DAYS", y: 4 },
        { x: ">30 DAYS", y: 12 },
      ],
    },
    {
      name: "Site 04",
      data: [
        { x: "0–2 DAYS", y: 4 },
        { x: "3–5 DAYS", y: 3 },
        { x: "6–10 DAYS", y: 8 },
        { x: "11–15 DAYS", y: null },
        { x: "16–30 DAYS", y: 3 },
        { x: ">30 DAYS", y: 7 },
      ],
    },
    {
      name: "Site 05",
      data: [
        { x: "0–2 DAYS", y: 5 },
        { x: "3–5 DAYS", y: 2 },
        { x: "6–10 DAYS", y: 5 },
        { x: "11–15 DAYS", y: 3 },
        { x: "16–30 DAYS", y: 4 },
        { x: ">30 DAYS", y: 6 },
      ],
    },
  ];

  const options = {
    chart: {
      type: "heatmap",
      toolbar: {
        show: false,
      },
    },

    dataLabels: {
      enabled: true,
      style: {
        colors: ["#1e293b"],
      },
    },

    stroke: {
      width: 2,
      colors: ["#ffffff"],
    },

    plotOptions: {
      heatmap: {
        radius: 4,

        colorScale: {
          ranges: [
            {
              from: 0,
              to: 0,
              color: "#e5e7eb",
              name: "empty",
            },
            {
              from: 1,
              to: 5,
              color: "#f8dede",
            },
            {
              from: 6,
              to: 10,
              color: "#f3bcbc",
            },
            {
              from: 11,
              to: 20,
              color: "#ef8f8f",
            },
            {
              from: 21,
              to: 100,
              color: "#ff3b30",
            },
          ],
        },
      },
    },

    legend: {
      show: false,
    },

    xaxis: {
      labels: {
        style: {
          fontWeight: 600,
        },
      },
    },

    yaxis: {
      labels: {
        style: {
          fontWeight: 600,
        },
      },
    },

    tooltip: {
      y: {
        formatter: (val) => `${val ?? 0} unresolved queries`,
      },
    },
  };

  return (
    <>
      <div className="p-3">
        <Chart options={options} series={series} type="heatmap" height={200} />
      </div>
    </>
  );
};

export default SiteAgingHeatmap;
